export default __webpack_public_path__ + "6da80665492c9640ebb8a155eec4e22d.png";